import { supabase } from '@/integrations/supabase/client';
import type { DiagnosticoReenvio } from './consultarReenvioComercial';

export async function registrarDiagnosticoRevisao(args: {
  leadId: string; pedidoId: string; userId: string; diagnostico: DiagnosticoReenvio;
}): Promise<boolean> {
  const rpc = supabase.rpc.bind(supabase) as unknown as (funcao: string, parametros: Record<string, unknown>) =>
    PromiseLike<{ error: unknown }>;
  const { error } = await rpc('registrar_regra_revisao_proposta', {
    p_lead_id: args.leadId, p_pedido_id: args.pedidoId, p_codigo: args.diagnostico.codigo,
    p_motivo: args.diagnostico.motivo, p_acao: args.diagnostico.acao,
    p_detalhes: args.diagnostico.detalhes, p_user_id: args.userId,
  });
  if (error) {
    console.error('[regra-revisao-proposta] não registrou diagnóstico', error);
    return false;
  }
  return true;
}
